import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithReauth from '../../app/baseQueryWithOnlineCourse'
import { CuratorStudentState, ListResponse, CourseState } from '../types'
import { update } from 'lodash'

interface fetchAllStudentsParams {
    filter: string
    size: number
    page: number
    courseId: number
}

export const curatorStudentsApiSlice = createApi({
    reducerPath: 'curatorApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Student', 'Course'],
    endpoints: (build) => ({
        fetchAllStudents: build.query<
            ListResponse<CuratorStudentState>,
            fetchAllStudentsParams
        >({
            query: (params) => ({
                url: `curator/students`,
                params,
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.data.map(({ id }) => ({
                            type: 'Student' as const,
                            id,
                        })),
                        { type: 'Student', id: 'LIST' },
                    ]
                    : [{ type: 'Student', id: 'LIST' }],
            transformResponse: (response: {
                data: ListResponse<CuratorStudentState>
            }) => ({
                data: response.data.data,
                pageNumber: response.data.pageNumber,
                totalCount: response.data.totalCount,
                totalPages: response.data.totalPages,
            }),
        }),
        fetchCuratorCourses: build.query<ListResponse<CourseState>, void>({
            query: () => ({
                url: `curator/courses`,
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.data.map(({ id }) => ({
                            type: 'Course' as const,
                            id,
                        })),
                        { type: 'Course', id: 'LIST' },
                    ]
                    : [{ type: 'Course', id: 'LIST' }],
        }),
        fetchStudentProgress: build.query<CuratorStudentState, { userCourseEnrollId: number }>({
            query: ({ userCourseEnrollId }) => ({
                url: `curator/students/${userCourseEnrollId}`,
            }),
            transformResponse: (response: {
                data: CuratorStudentState
            }) => response.data,
            providesTags: (result, error, { userCourseEnrollId }) => [
                { type: 'Student' as const, id: userCourseEnrollId },
            ],
        }),

        updateStudentPerformance: build.mutation<void, { userCourseEnrollId: number, performanceLevel: string }>({
            query: ({ userCourseEnrollId, performanceLevel }) => ({
                url: `curator/students/performance`,
                method: 'POST',
                body: { userCourseEnrollId, performanceLevel },
            }),
            invalidatesTags: (result, error, { userCourseEnrollId }) => [
                { type: 'Student', id: 'LIST' },
                { type: 'Student', id: userCourseEnrollId },
            ],
        }),

    }),
})
